// CONSTANTS are all caps.
const NS = 'Sidebar';
const CLS = 'sidebar';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/sidebar.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

// import form validation library
import vivalid from 'vivalid';
import * as utils from '../../../../global/js/utils';

export class Sidebar {
	constructor($el) {
		// $el is the widget node return by the loadSidebar function
		this.$el = $el;
	}

	init() {
		this.setSidebar();
	}

	setSidebar() {
		// Add Some logic here
		const $wg = $(this.$el);
		let sidebarCloseBtn = $wg.find('.sidebar-toggle.is-close');

		sidebarCloseBtn.hide();
		$wg.find('.sidebar-toggle:not(.no-tab)').on('click', function(e) {
			let This = $(this);
			let tab = This.next('.sidebar-tabContent');

			if (utils.isOnMobile()) {
				$('.sidebar-tabContent').not(tab).slideUp(0).removeClass('active');
				if (This.is('.active')) {
					tab.slideUp(300).removeClass('active');
					This.removeClass('active');
				} else {
					tab.slideDown(300).addClass('active');
					This.toggleClass('active');
				}
			} else {
				if (This.is('.active')) {
					This.find('span').unbind('mouseenter mouseleave');
					hideSidebar(This);
					return false;
				} else {
					$('.sidebar-tabContent').not(tab).fadeOut(0).removeClass('active');
					tab.fadeIn(300).addClass('active');
					This.not('.is-close').addClass('active');
				}
			}


			$('.sidebar-toggle').not(This).removeClass('active');

			let activeTabs = $wg.find('.sidebar-toggle.active').length;

			if (!utils.isOnMobile()) {
				if (($wg.hasClass('is-expanded') && (activeTabs === 0)) || This.is('.is-close')) {
					hideSidebar(This);
				} else {
					showSidebar(This);
				}
			}

			function hideSidebar($btn) {
				$wg.animate({right: '-390px'}, 300, function() {
					$wg.removeClass('is-expanded');
					sidebarCloseBtn.hide();
					if ($btn.is('.active, .is-close')) {
						$wg.find('.sidebar-toggle, .sidebar-tabContent').removeClass('active');
					}
				});
			}

			function showSidebar($btn) {
				$wg.animate({right: '0'}, 500, function() {
					$wg.addClass('is-expanded');
					sidebarCloseBtn.show();
				});
			}
		});

		let $promoCode = $wg.find('#promoCode');
		let $promoCodeField = $wg.find('.promo-code');
		let $resetBtn = $wg.find('#resetBtnSidebar');

		$promoCode.on('change', function() {
			$resetBtn.trigger('click');
			if ($(this).is(':checked')) {
				$promoCodeField.fadeIn(0);
			} else {
				$promoCodeField.fadeOut(0);
			}
		});

		// call the rules
		// sidebar contains 1 form(s) only
		// if ($(document).find('form').length <= 1) {
		// 	utils.formValidationRules();
		// }

        // let addCallback = vivalid.htmlInterface.addCallback;
        // let initAllValidations = vivalid.htmlInterface.initAll;

        // addCallback('onValidationSuccessSidebar', function() {
        //     let $form = $wg.find('form');
		// 	// submit, if this is an ajax call, replace with an ajax call
		// 	$form.submit();
        // });

        // addCallback('onValidationFailureSidebar', function(invalid, pending, valid) {
		// 	// invalid ...
		// 	// no submission goes through
        // });

		// sidebar contains 2 forms only
		// if ($(document).find('form').length <= 2) {
		// 	initAllValidations();
		// }

		// this code closes the sidebar if user clicks outside it, it causes issues with minicart
		// it causes issues once clicking on the popup confirmation to remove the items from the minicart
		// $(document).mouseup(function(e) {
		// 	// if the target of the click isn't the container nor a descendant of the container
		// 	if (!utils.isOnMobile()) {
		// 		if (!$wg.is(e.target) && $wg.has(e.target).length === 0) {
		// 			// find current active tab
		// 			let This = $wg.find('.sidebar-toggle.active');
		// 			$wg.animate({right: '-390px'}, 300, function() {
		// 				$wg.removeClass('is-expanded');
		// 				sidebarCloseBtn.hide();
		// 				$(This.attr('href')).toggleClass('active');
		// 				This.toggleClass('active');
		// 				$('.sidebar-tabContent').fadeOut(0).removeClass('active');
		// 			});
		// 		}
		// 	}
		// });
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/sidebar/js/sidebar.js